import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Spin from 'antd/lib/spin';
import rules from '../../../common/rules/rules';
import PaymentInstructions from '../../allocations/components/PaymentInstructions'
import Table from 'antd/lib/table';
import { formatDate, currencyFormatter, percentageFormatter } from '../../../common/utils/helpers';
import { Link } from 'react-router';

const { Column } = Table;


@translate()
@Form.create()
export default class AccountOverview extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    onWithdraw: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoadingAccountOverview: PropTypes.bool.isRequired,
    accountBalance: PropTypes.number.isRequired,
    accountOverview: PropTypes.object.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields({ force: true }, (err, values) => {
      if (!err) {
        let amount = values.amount.replace(',','.')
        console.log(amount)
        this.props.onWithdraw(amount);
      }
    });
  };

  totalValueOfAccount = () => {
    const pending = parseFloat(this.props.accountOverview.pendingAllocationsSum)
    const unpaidPrincipal = parseFloat(this.props.accountOverview.unPaidPrincipalSum)
    return currencyFormatter(unpaidPrincipal + this.props.accountBalance + pending)
  }

  
  percentOfPaid = (value) => {
    if (value === 0){
      return (percentageFormatter(value))
    }
    const paid = parseFloat(this.props.accountOverview.paidAmountSum)
    const unpaidnotlate = parseFloat(this.props.accountOverview.unPaidNotLateSum)
    const unpaidlate = parseFloat(this.props.accountOverview.unPaidLateSum)
    return percentageFormatter((value / (paid + unpaidlate + unpaidnotlate)).toFixed(4)) 
  }

  scrollToWithdraw = () => {
    this.withdrawRef.scrollIntoView({ behavior: 'smooth'})
    this.focusRef.focus()
  }


  scrollToInvest = () =>
    this.investRef.scrollIntoView({ behavior: 'smooth'})
  
  render(){
    const { 
      t, 
      isLoading, 
      isLoadingAccountOverview,
      accountBalance,
      accountOverview
      
      
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Spin spinning={isLoadingAccountOverview}>
        <div>
          <section className="panel-wrapper">
            <Col>
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Môj účet</h2>
                <Row className={"overview-row overview-row-first"} between={'lg'}>
                  <p >Aktuálna hodnota účtu: </p> <p className="p-in-table">{this.totalValueOfAccount()}</p>
                </Row>
                <Row className="overview-row" between={'lg'}>
                  <p >Voľné zdroje: </p> <p className="p-in-table">{currencyFormatter(accountBalance)}</p>
                </Row>
                <Row className="overview-row " between={'lg'}>
                  <p >Zdroje v ponukách: </p> <p className="p-in-table">{currencyFormatter(accountOverview.pendingAllocationsSum)}</p> 
                </Row>
            </Col> 

            <Row >
              <Col > 
                <Button  size="small" className="buttons-overview" type="primary" onClick={this.scrollToInvest}> {t('Vklad')} </Button> 
              </Col>  
              <Col > 
                <Button  size="small" className="buttons-overview" type="primary" onClick={this.scrollToWithdraw}> {t('Výber')} </Button>
              </Col>
              <Col > 
                <Link to="dashboard/create-investment">
                  <Button  size="small" style={{display: 'inline-block', marginTop: 20+'px'}} type="primary"> {t('Nová investícia')} </Button>
                </Link>
              </Col>
            </Row>
          </section>
          
        
          <br></br>    
          <Row className="withdraw-funds-wrapper" >
            <section className="withdraw-funds-wrapper col-xs-12 col-md-6 " >
              <section className="panel-wrapper">
                <h2 style={{color: "#0A4892", textAlign: 'left'}}>Investičná výnosnosť</h2>
                {/* <Row between={'lg'} className="overview-row overview-row-second">
                  <p >Investičný výnos: </p> <p style={{padding: 5+'px'}} className="p-in-table">0.00% p.a.</p> 
                </Row> */}
                <Row between={'lg'} className="overview-row overview-row-second">
                  <p >Investované celkom: </p><p style={{padding: 5+'px'}} className="p-in-table">{currencyFormatter(accountOverview.allAllocationsSum)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p >Inkasované splátky: </p> <p className="p-in-table">{currencyFormatter(accountOverview.paidAmountSum)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Inkasovaná istina: </p> <p className="p-in-table">{currencyFormatter(accountOverview.paidPrincipalSum)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Inkasované úroky: </p> <p className="p-in-table">{currencyFormatter(accountOverview.paidInterestSum)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p style={{marginLeft: 30+'px'}}>Inkasované za odpredaj: </p> <p className="p-in-table"> {currencyFormatter(accountOverview.paidDisposedSum)}</p>
                </Row>
                <Row between={'lg'} className="overview-row">
                  <p >Inkasované za predaj na sekundárnom trhu: </p> <p className="p-in-table"> {currencyFormatter(accountOverview.sumOfSelledAllocations)}</p>
                </Row>
                <Row between={'lg'} className="overview-row ">
                  <p >Očakávané splátky: </p><p className="p-in-table"> {currencyFormatter(accountOverview.unPaidAmountSum)}</p>
                </Row>
              </section>  
            </section>
            <section className="panel-wrapper col-xs-12 col-md-6 " >
              <h2 style={{color: "#0A4892", textAlign: 'left'}}>Moje portfólio</h2>
              <Row between={'lg'} className="overview-row overview-row-third">
                <p >Aktívne investície: </p> <p className="p-in-table">{currencyFormatter(accountOverview.activeInvestSum)}</p>
              </Row>
              <Row between={'lg'} className="overview-row">
                <p >Ukončené investície: </p> <p className="p-in-table">{currencyFormatter(accountOverview.closedInvestSum)}</p>
              </Row>
              <Row between={'lg'} className="overview-row">
                <p >Inkasované splátky: </p> <p className="p-in-table"> {currencyFormatter(accountOverview.paidAmountSum)} / {this.percentOfPaid(parseInt(accountOverview.paidAmountSum))}</p>
              </Row>
              <Row between={'lg'} className="overview-row">
                <p >Splácané: </p> <p className="p-in-table"> {currencyFormatter(accountOverview.unPaidNotLateSum)} / {this.percentOfPaid(parseInt(accountOverview.unPaidNotLateSum))}</p>
              </Row>
              <Row between={'lg'} className="overview-row ">
                <p >V omeškaní (+90 dní): </p> <p className="p-in-table"> {currencyFormatter(accountOverview.unPaidLateSum)} / {this.percentOfPaid(parseInt(accountOverview.unPaidLateSum))}</p>
              </Row>
            </section>
          </Row>
          <br></br>
          <Row className="withdraw-funds-wrapper">
              <section ref={ (ref) => this.investRef=ref } className="withdraw-funds-wrapper col-xs-12 col-md-6">
                <PaymentInstructions></PaymentInstructions>
              </section>
              <section ref={(ref) => this.withdrawRef=ref} className="withdraw-funds-wrapper panel-wrapper col-xs-12 col-md-6">
                <Row>
                  <Col xs={12}>
                    <h2>{t('Výber peňazí')}</h2>
                  </Col>
                  <Col xs={12} md={12} >
                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        <Col xs={8} md={8}>
                          <Form.Item>
                            {getFieldDecorator('amount', {
                              rules: rules.withdrawalAmount(accountBalance),
                            })(<Input ref={(ref) => this.focusRef=ref} size="default" placeholder={t('Zadajte sumu')} />)}
                          </Form.Item>
                        </Col>
                        <Col xs={4} md={4}>
                          <Form.Item>
                            <Button size="small" type="primary" htmlType="submit">
                              {t('Odoslať')}
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </section>
            </Row>
        </div>
      </Spin>
    
        
    )
  
  }

}


// WEBPACK FOOTER //
// ./src/features/overview/components/AccountOverview.js